import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useBranches } from '../../hooks';
import type { Branch, BranchFilters } from '../../models';

export interface BranchFieldProps extends Omit<SelectProps<Branch>, 'options'> {
  defaultFilters?: Partial<BranchFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<Branch>['errorMessage'];
  isInvalid?: boolean;
}

export const BranchField: React.FC<BranchFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = useBranches(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { branchDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { branchDesc: search } })}
      isLoading={isLoading}
    />
  );
};
